import { LoginButton } from "@/components/auth";
import { APP_CONFIG } from "@/constants/app";

export const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {APP_CONFIG.TITLE}
          </h1>
          <p className="text-gray-600 mb-8">
            Faça login para acessar o sistema
          </p>
        </div>

        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-6">
            <div className="text-center">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Autenticação
              </h2>
              <p className="text-sm text-gray-600 mb-6">
                Clique no botão abaixo para fazer login através do Keycloak
              </p>

              <LoginButton variant="primary" size="lg" className="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
